module.exports = __webpack_public_path__ + "media/images/athletes/1731-cef6d0b09eb3c2fdf2136ad922ae6ba9.png";